import React, { memo } from 'react';
import { BTN_VISUAL_TYPES } from './Constants';
const ContentWrapper = _ref => {
  let {
    children,
    btnType
  } = _ref;
  return BTN_VISUAL_TYPES.indexOf(btnType) >= 0 ? /*#__PURE__*/React.createElement("div", {
    className: "visual"
  }, children) : children;
};
export default /*#__PURE__*/memo(ContentWrapper);